import React ,{ useState } from 'react'
import {Link} from "react-router-dom";

const Main = ({gredient}) => {

    const[activeFaq, setActiveFaq] = useState({a : true})

  return (
    <>
        <section className="row_am faq_section">
        {gredient && <div className="faq_bg"> <img src="/assets/images/section-bg.png" alt="image"/> </div>}
            <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="300">
                    <h2><span>FAQ</span> - Frequently Asked Questions</h2>
                    <p>See some of our frequently asked questions below, if you have any other questions feel free to drop us a message!</p>
                </div>
                <div className="faq_panel">
                    <div className="accordion" id="accordionExample">
                        <div className="card"  data-aos-duration="1500">
                            <div className="card-header" id="headingOne">
                                <h2 className="mb-0">
                                <button type="button" className={`btn btn-link ${activeFaq.a && "active"}`} onClick= {() => setActiveFaq(activeFaq.a ? {a : false} : {a : true})} data-toggle="collapse" data-target="#collapseOne">
                                {activeFaq.a ? <i className="icon_faq icofont-minus"></i>  : <i className="icon_faq icofont-plus"></i>} Is there a minimum subscription length?</button>
                                </h2>
                            </div>
                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div className="card-body">
                                <p>There's a minimum of 1 month subscription with every new account, if you would like a demonstration feel free to drop us a email or give us a call!.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card"  data-aos-duration="1500">
                            <div className="card-header" id="headingTwo">
                                <h2 className="mb-0">
                                <button type="button" className={`btn btn-link ${activeFaq.b && "active"}`} onClick= {() => setActiveFaq(activeFaq.b ? {b : false} : {b : true})} data-toggle="collapse"
                                    data-target="#collapseTwo">{activeFaq.b ? <i className="icon_faq icofont-minus"></i>  : <i className="icon_faq icofont-plus"></i>} How to setup account ?</button>
                                </h2>
                            </div>
                            <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div className="card-body">
                                <p>Setting up an account is easy! Simply head over to the <Link to={'/register'}>Register</Link> page to start the process, it only takes a few minutes and you'll be up and running!</p>
                                </div>
                            </div>
                        </div>
                        <div className="card"  data-aos-duration="1500">
                            <div className="card-header" id="headingThree">
                                <h2 className="mb-0">
                                <button type="button" className={`btn btn-link ${activeFaq.c && "active"}`} onClick= {() => setActiveFaq(activeFaq.c ? {c : false} : {c : true})} data-toggle="collapse"
                                    data-target="#collapseThree">{activeFaq.c ? <i className="icon_faq icofont-minus"></i>  : <i className="icon_faq icofont-plus"></i>}Can I import and export my data?</button>
                                </h2>
                            </div>
                            <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div className="card-body">
                                <p>Certainly! We know the struggles of setting up a new system and exporting your data once you're finished so we made it super simple. Every module has it's own dedicated import and export section. We also provide a full project export service upon completion of your project!</p>
                                </div>
                            </div>
                        </div>
                        <div className="card"  data-aos-duration="1500">
                            <div className="card-header" id="headingFour">
                                <h2 className="mb-0">
                                <button type="button" className={`btn btn-link ${activeFaq.d && "active"}`} onClick= {() => setActiveFaq(activeFaq.d ? {d : false} : {d : true})} data-toggle="collapse"
                                    data-target="#collapseFour">{activeFaq.d ? <i className="icon_faq icofont-minus"></i>  : <i className="icon_faq icofont-plus"></i>}How does AI integrate into Accord?</button>
                                </h2>
                            </div>
                            <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div className="card-body">
                                <p>We've spent time integrating AI into Accord giving you the option of utilising AI to run reports on your data. Simply sign up to OpenAI and grab your API key, head over to the "Ask AI" section within Accord and allocate your API key, that's it! Ask AI anything to do with your project and data and get a response within seconds.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card"  data-aos-duration="1500">
                            <div className="card-header" id="headingFour">
                                <h2 className="mb-0">
                                <button type="button" className={`btn btn-link ${activeFaq.d && "active"}`} onClick= {() => setActiveFaq(activeFaq.d ? {d : false} : {d : true})} data-toggle="collapse"
                                    data-target="#collapseFour">{activeFaq.d ? <i className="icon_faq icofont-minus"></i>  : <i className="icon_faq icofont-plus"></i>}Do I have to use all of Accords vast features?</button>
                                </h2>
                            </div>
                            <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div className="card-body">
                                <p>Of course not, Accord provides the ability to create and manage your own User Roles. This means you decide what you and your team see's and uses within Accord.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main